//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import * as Utils from "eai-configurator-ui/components/Utils";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import RemoveIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  table: {
    minWidth: 300,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: "1 1 100%",
  },
}));

export default function AutomateDatabasesTable({
                                                 setAlertMessage,
                                                 refreshCounter,
                                                 handleEditAutomateDatabase,
                                                 handleRunDatabaseNow,
                                                 handleDeleteDatabase
                                               }) {
  const classes = useStyles();
  const [automateDatabases, setAutomateDatabases] = React.useState([]);
  const [remarks, setRemarks] = React.useState([]);

  React.useEffect(() => {
    populateTable();
  }, [refreshCounter]);

  const populateTable = () => {
    Utils.fetchData("loader/automateDatabases")
      .then((data) => {
        setAutomateDatabases(data.databases);
        setRemarks(data.remarks);
      })
      .catch(function (response) {
        Utils.getErrorMessage(response, "Failed to fetch job databases.").then(
          (message) =>
            setAlertMessage({
              success: false,
              message: message,
            })
        );
      });
  };

  const isTableNotEmpty = automateDatabases && automateDatabases.length > 0;
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table}>
            {isTableNotEmpty && (
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align="center">Instance Name</TableCell>
                  <TableCell align="center">Username</TableCell>
                  <TableCell align="center">Allow Automation</TableCell>
                  <TableCell align="center">Active Profile</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {automateDatabases && automateDatabases.map((automateDatabase, index) => (
                <TableRow key={index} hover role="task" tabIndex={-1}>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {automateDatabase.instanceNumber}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {automateDatabase.instanceName}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {automateDatabase.username}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {(automateDatabase.automate ? "Yes" : "No")}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {automateDatabase.selectedProfileName}
                  </TableCell>
                  <TableCell
                    align="right"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {automateDatabase.automate && (
                      <Button
                        variant="contained"
                        color={"primary"}
                        className={classes.button}
                        onClick={() => handleRunDatabaseNow(automateDatabase)}
                        startIcon={
                          <DirectionsRun/>
                        }
                      >
                        Run Jobs
                      </Button>
                    )}
                    <Tooltip title="Edit Database">
                      <IconButton
                        onClick={() => {
                          handleEditAutomateDatabase(automateDatabase);
                        }}
                      >
                        <EditIcon/>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Database">
                      <IconButton
                        onClick={() => {
                          handleDeleteDatabase(automateDatabase);
                        }}
                      >
                        <RemoveIcon/>
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {!isTableNotEmpty && (
                <TableRow style={{height: 53}}>
                  <TableCell>
                    <Typography align="center" color="textSecondary">
                      No databases
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          spacing={1}
          style={{paddingTop: 15, paddingLeft: 15, paddingBottom: 15}}
        >
          {remarks && remarks.map((item) => (
            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
              <Typography variant="caption" color="textSecondary">
                {item}
              </Typography>
            </Grid>))}
        </Grid>
      </Paper>
    </div>
  );
}
